import { FC } from "react";
import { ChartLegendProps } from "./types";
import { Row } from "../containers";
import { Heading } from "../typography";
import { useThemeStore } from "../../stores";

const ChartLegend: FC<ChartLegendProps> = ({color, label, className, props, style}) => {
    const theme = useThemeStore(s => s.theme);

    return <Row gap={8} className={className} props={props} style={style} >
        <div style={{width: 10, height: 10, background: color, borderRadius: 5}} ></div>
        <Heading color={theme.textOnOverlay} >{label}</Heading>
    </Row>
}

export default ChartLegend;